// A lista é da rota-pai (`app.transactions.tsx`), porque ela continua desenhada embaixo
// quando o detalhe abre no drawer (`spec/24` §1 decisão 5). Esta rota-índice existe só
// para `/app/transactions` ser um destino válido do roteador.

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/app/transactions/')({ component: () => null });
